import { defaultClient } from '@mint-sdk/api-core';

import {
  VirtualDspCampaignQuerySchema,
  VirtualDspCampaignResponseSchema,
} from '../shared/schemas/virtualDspCampaign.js';

export const getVirtualDspCampaignQueryOptions = defaultClient.query({
  url: 'planning-service/virtuals/virtual-dsp-campaigns/',
  method: 'GET',
  querySchema: VirtualDspCampaignQuerySchema,
  snakeCaseQueryParams: true,
  responseSchema: VirtualDspCampaignResponseSchema,
  processResponse: (data) => {
    return data;
  },
});
